import { useEffect, useState } from 'react';

/**
 * Used to render a genuinely different mobile layout rather than hiding desktop
 * markup with CSS: on a phone the compact variants carry less DOM, not just
 * fewer visible pixels.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export function useIsPhone(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
